import { defineComponent as _defineComponent } from 'vue'
import PayoutDateInput from "@/components/forms/payout/forms/PayoutDateInput.vue";
import HorizontalFormGroup from "@/components/forms/horizontal/HorizontalFormGroup.vue";
import MultipleDocumentFilesTableUpload
  from "@/components/forms/files/MultipleDocumentFilesTableUpload.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import {computed, getCurrentInstance, ref, watch} from "vue";
import VueI18n from "vue-i18n";
import moment from "moment-timezone";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressVerificationDocument',
  props: {
  maxFilesPerDocument: {
    type: Number,
    default: 3
  },
  value: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  },
  model: {
    type: Object,
    default: null
  },
  modelAttributesPrefix: {
    type: String,
    default: 'addressDocument'
  }
},
  emits: ['input'],
  setup(__props, { expose, emit: emits }) {

const props = __props;




const addressDocumentTypeOptions = computed(() => {
  const i18n = getCurrentInstance()?.proxy.$i18n as VueI18n;

  const values = {
    ['DOMESTIC_UTILITY_BILL']: 'Коммунальная квитанция',
    ['INTERNATIONAL_UTILITY_BILL']: 'Заграничная коммунальная квитанция',
    ['TELEPHONE_BILL']: 'Телефонный счет',
    ['BANK_ACCOUNT_STATEMENT']: 'Выписка из банковского счета',
  }

  const result = {};

  Object.keys(values).forEach((item) => {
    result[item] = i18n ? i18n.t(values[item]) : values[item];
  });

  return result;
})

const addressDocumentDatePickerOptions = computed(() => {
  const i18n = getCurrentInstance()?.proxy.$i18n as VueI18n;

  return {
    range: false,
    dateFormat: 'dd.MM.yyyy',
    minDate: moment().subtract(5, 'months').toDate(),
    maxDate: moment().toDate(),
    view: 'days',
    //minView: 'months',
    autoClose: true,
    language: i18n ? i18n.locale : 'ru'
    //language: //document.getElementsByTagName("html")[0].getAttribute("lang")
  }
})

const addressDocumentType = ref('');
const addressDocumentValidFrom = ref('');
const addressDocumentFiles = ref([]);

const documentInfo = computed(() => {
  return addressDocumentFiles.value.map((file) => {
    return {
      id: file.id,
      file: file,
      type: addressDocumentType.value,
      validFrom: addressDocumentValidFrom.value
    }
  })
})

const resetDocument = () => {
  addressDocumentType.value = '';
  addressDocumentValidFrom.value = '';
  addressDocumentFiles.value = [];
}



watch(() => [addressDocumentType.value, addressDocumentValidFrom.value,
  addressDocumentFiles.value.join(',')].join(':'), (value) => {
  emits('input', documentInfo.value);
})

const isUploading = () => {
  return addressDocumentFiles.value.some((file) => file.uploading);
}

const documentSelector = ref(null)

const busy = computed(() => {
 return documentSelector.value.busy || isUploading();
})

expose({documentInfo, resetDocument, busy})

return { __sfc: true,props, addressDocumentTypeOptions, addressDocumentDatePickerOptions, addressDocumentType, addressDocumentValidFrom, addressDocumentFiles, documentInfo, resetDocument, emits, isUploading, documentSelector, busy, PayoutDateInput, HorizontalFormGroup, MultipleDocumentFilesTableUpload, PayoutInputHintBlock, DropdownKeyvalue, ErrorMessageBlock }
}

})